<template>
    <div :class="['page-view', {loaded: !loading}]">
        <Breadcrumb/>
        <transition name="fade" mode="out-in">
            <div class="page-view-gabarit">
                <div class="heading separated">
                    <div class="block">
                        <h1>{{$t('nav.sitemap')}}</h1>
                    </div>
                </div>
                <div class="footer">
                    <div class="block" v-if="sitemap && sitemap.links">
                        <div v-for="(item, i) in sitemap.links" :key="i">
                            <div v-if="item.active">
                                <h2>
                                    <router-link :to="item.link">
                                        {{ item.title }}
                                    </router-link>
                                </h2>
                            </div>
                            <div v-for="(sub, j) in item.sublinks" :key="j">
                                <div  v-if="sub.active">
                                    <h3>
                                        <router-link :to="sub.link">
                                            {{ sub.title }}
                                        </router-link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import PageView from '@/components/MixinPageView'
export default {
    name: 'page',
    mixins: [PageView],
    data() {
        return {
            sitemap: null
        }
    },
    mounted()
    {
        this.$nextTick(() => {
            this.loading = false
            window.scroll(0, 0)
        })
    },
    created()
    {
        this.getPage({id: 'sitemap'}).then((e) => {
            this.sitemap = e
        });
    },
    watch: {
        '$route.params.locale'() {
            this.getPage({id: 'sitemap'}).then((e) => {
                this.sitemap = e
            });
        },
        '$route'() {
            this.getPage({id: 'sitemap'}).then((e) => {
                this.sitemap = e
            });
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.page-view-gabarit
    overflow-y: visible
.page-view-gabarit
    .block
        padding-top: 4%
        padding-bottom: 4%
        max-width: 1590px
        margin-left: auto
        margin-right: auto
        display: flex
        flex-direction: column
        padding-left: 9.6%
        padding-right: 9.6%
        a
            text-decoration: none
        h2
            font-size: 36px
            font-weight: 500
            margin-top: 1.2em
            @include media-breakpoint-down($md)
                font-size: 20px
        h3
            font-size: 22px
            font-weight: 500
            padding-top: .5em
            padding-bottom: .25em
            @include media-breakpoint-down($md)
                font-size: 18px
    .row
        display: flex
        &+.row
            padding-top: 4.25%
.heading
    margin-top: 8.25%

    &:after
        margin-top: 7.5%
.separated
    &:after
        content: ""
        display: block
        width: 100%
        height: 4px
        background-image: url('./../../assets/circle.svg')
        height: 12px
        opacity: .3
.box
    flex: 1
    &+.box
        margin-left: 80px
h1
    font-size: 86px
    color: #ff2b2a
    font-weight: 500
    letter-spacing: -0.03125em
    @include media-breakpoint-down($md)
        font-size: 50px
</style>
